import { isApiError } from '@rconf/api-client';

export function accountAuthError(error, context = 'password') {
  const status = isApiError(error) ? error.status : Number(error?.status || 0);
  const retryAfter = retryAfterFromError(error);

  if (status === 0) {
    return { message: 'Нет соединения с сервером. Проверьте интернет и повторите попытку.', retryAfter: 0 };
  }
  if (status === 429) {
    return {
      message: retryAfter
        ? `Слишком много попыток. Повторите через ${retryAfter} сек.`
        : 'Слишком много попыток. Подождите немного и повторите.',
      retryAfter,
    };
  }
  if (status === 401 || status === 404) {
    if (context === 'rendall-code') return { message: 'Код неверен или уже истёк.', retryAfter: 0 };
    if (context === 'rendall-request') return { message: 'Пользователь Rendall не найден.', retryAfter: 0 };
    return { message: 'Неверный e-mail или пароль.', retryAfter: 0 };
  }
  if (status === 403) {
    return { message: 'Учётная запись заблокирована или у неё недостаточно прав.', retryAfter: 0 };
  }
  if (status === 422) {
    return { message: 'Проверьте введённые данные.', retryAfter: 0 };
  }
  if (status >= 500) {
    return { message: 'Сервис входа временно недоступен. Попробуйте позже.', retryAfter: 0 };
  }
  return { message: 'Не удалось войти. Повторите попытку.', retryAfter: 0 };
}

function retryAfterFromError(error) {
  const value = error?.details?.retry_after
    ?? error?.responseBody?.detail?.retry_after
    ?? error?.responseBody?.retry_after;
  const seconds = Number(value || 0);
  return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : 0;
}
